export default __webpack_public_path__ + "static/alexander-150x150-0760c0bd96e3f8b6f135255dd7ab8af7.png";